const reviews = [
  {
    name: 'Mark & Sandra T.',
    location: 'Portage, MI',
    initials: 'MT',
    stars: 5,
    text: 'DOC Electric did a full panel upgrade and installed an EV charger for us. From the first call to the final walkthrough, everything was professional, clean, and on budget. These are the only electricians I\'ll call.',
  },
  {
    name: 'James R.',
    location: 'Kalamazoo, MI',
    initials: 'JR',
    stars: 5,
    text: 'We had them wire our entire new construction build. They showed up every day on schedule, communicated constantly with the builder, and their work passed every inspection on the first try. Exceptional quality.',
  },
  {
    name: 'Rebecca L.',
    location: 'Mattawan, MI',
    initials: 'RL',
    stars: 5,
    text: 'After a scary electrical issue, DOC Electric came out quickly, diagnosed the problem honestly, and fixed it without trying to upsell anything. They were respectful, clean, and genuinely cared about our safety.',
  },
  {
    name: 'Chris & Amy W.',
    location: 'Plainwell, MI',
    initials: 'CW',
    stars: 5,
    text: 'Specialty lighting installation throughout our home — every fixture was placed perfectly, the wiring is immaculate, and the final result looks stunning. These guys are true craftsmen.',
  },
  {
    name: 'David H.',
    location: 'Kalamazoo, MI',
    initials: 'DH',
    stars: 5,
    text: 'As a property manager, I need reliable contractors I can trust. DOC Electric handles all my electrical work — fast response, clear communication, fair pricing, and impeccable work. Highly recommended.',
  },
];

const StarRating = ({ count }: { count: number }) => (
  <div className="flex items-center gap-1">
    {Array.from({ length: count }).map((_, i) => (
      <span key={i} className="w-4 h-4 flex items-center justify-center">
        <i className="ri-star-fill text-[#00D9FF] text-[14px]" />
      </span>
    ))}
  </div>
);

const Testimonials = () => (
  <section id="reviews" className="relative bg-[#F4F7FB] py-28 overflow-hidden">
    {/* Accent detail */}
    <div className="absolute top-0 left-0 right-0 h-[2px] bg-gradient-to-r from-transparent via-[#00D9FF]/20 to-transparent" />

    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      {/* Header */}
      <div className="text-center mb-16 scroll-reveal">
        <span className="inline-block text-[#00D9FF] text-[11px] font-semibold uppercase tracking-[3px] mb-4">Client Testimonials</span>
        <h2 className="text-4xl lg:text-5xl font-black text-[#0A1628] mb-4">
          Trusted by Kalamazoo Homeowners
        </h2>
        <p className="text-[#5A7A96] text-lg max-w-lg mx-auto">
          Real words from real customers. We let our work — and our relationships — speak for themselves.
        </p>
      </div>

      {/* Reviews scroll grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {reviews.slice(0, 3).map((review, i) => (
          <div key={review.name} className={`scroll-reveal scroll-delay-${i + 1}`}>
            <ReviewCard review={review} />
          </div>
        ))}
      </div>

      {/* Second row — 2 cards centered */}
      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6 max-w-[65%] mx-auto hidden lg:grid">
        {reviews.slice(3).map((review, i) => (
          <div key={review.name} className={`scroll-reveal scroll-delay-${i + 1}`}>
            <ReviewCard review={review} />
          </div>
        ))}
      </div>

      {/* Mobile extra cards */}
      <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-6 lg:hidden">
        {reviews.slice(3).map((review, i) => (
          <div key={review.name} className={`scroll-reveal scroll-delay-${i + 1}`}>
            <ReviewCard review={review} />
          </div>
        ))}
      </div>

      {/* Bottom trust strip */}
      <div className="mt-16 flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-10 scroll-reveal">
        <div className="flex items-center gap-3 text-[#0A1628]">
          <span className="w-6 h-6 flex items-center justify-center">
            <i className="ri-google-fill text-[#DB4437] text-xl" />
          </span>
          <div>
            <div className="text-[15px] font-black">5.0 Stars</div>
            <div className="text-[12px] text-[#5A7A96] font-medium">Google Reviews</div>
          </div>
        </div>
        <div className="w-px h-8 bg-[#D8E6F0] hidden sm:block" />
        <div className="flex items-center gap-3 text-[#0A1628]">
          <span className="w-6 h-6 flex items-center justify-center">
            <i className="ri-facebook-fill text-[#1877F2] text-xl" />
          </span>
          <div>
            <div className="text-[15px] font-black">Highly Recommended</div>
            <div className="text-[12px] text-[#5A7A96] font-medium">Facebook Reviews</div>
          </div>
        </div>
        <div className="w-px h-8 bg-[#D8E6F0] hidden sm:block" />
        <div className="flex items-center gap-3 text-[#0A1628]">
          <span className="w-6 h-6 flex items-center justify-center">
            <i className="ri-verified-badge-fill text-[#00D9FF] text-xl" />
          </span>
          <div>
            <div className="text-[15px] font-black">Licensed & Vetted</div>
            <div className="text-[12px] text-[#5A7A96] font-medium">Michigan Electrical Contractor</div>
          </div>
        </div>
      </div>

      {/* Link to full reviews page */}
      <div className="mt-10 text-center scroll-reveal">
        <a
          href="/reviews"
          className="inline-flex items-center gap-2 px-6 py-3 border border-[#0A1628]/20 hover:border-[#00D9FF]/50 text-[#0A1628] hover:text-[#00D9FF] font-semibold text-[13px] uppercase tracking-wider rounded-lg transition-all duration-300 cursor-pointer"
        >
          See All 200+ Reviews
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line" />
          </span>
        </a>
      </div>
    </div>
  </section>
);

interface Review {
  name: string;
  location: string;
  initials: string;
  stars: number;
  text: string;
}

const ReviewCard = ({ review }: { review: Review }) => (
  <div className="group relative bg-white rounded-2xl p-8 border border-[#E4EDF6] hover:border-[#00D9FF]/30 hover:-translate-y-1.5 hover:shadow-[0_12px_40px_rgba(0,0,0,0.1)] transition-all duration-400 cursor-default overflow-hidden">
    {/* Blue quote mark */}
    <div className="absolute top-6 right-6 text-[#00D9FF]/10 text-8xl font-black leading-none select-none pointer-events-none">&ldquo;</div>

    {/* Stars */}
    <StarRating count={review.stars} />

    {/* Text */}
    <p className="mt-4 text-[#3A566E] text-[15px] leading-relaxed italic">
      &ldquo;{review.text}&rdquo;
    </p>

    {/* Attribution */}
    <div className="mt-6 flex items-center gap-3 pt-5 border-t border-[#EDF4FB]">
      <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#0A1628] text-white text-[13px] font-bold flex-shrink-0">
        {review.initials}
      </div>
      <div>
        <div className="text-[14px] font-bold text-[#0A1628]">{review.name}</div>
        <div className="text-[12px] text-[#7A9AB8]">{review.location}</div>
      </div>
    </div>
  </div>
);

export default Testimonials;
